import { IoEyeOffOutline, IoEyeOutline, IoSearchSharp } from "react-icons/io5";
import { useState, useRef, useEffect } from "react";
import classes from "./InputField.module.css";
import { FiSearch } from "react-icons/fi";

const InputField = ({
  labelText,
  className = "",
  inputContainerClass,
  labelStyle,
  type = "text",
  placeholder,
  showEye,
  search,
  onChange,
  required,
  disabled,
  name,
  value,
  showSearch = true,
  isTextarea = false, // ✅ New prop
  options = [], // Array of { value, label } or string
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const dropdownRef = useRef(null);
  const isSelect = options && options.length > 0;

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const selectedLabel = options.find((opt) => opt === value) || "";

  return (
    <div className={`${classes.wrapper} ${className}`}>
      {labelText && (
        <label style={labelStyle}>
          {labelText}
          {required && <span>*</span>}
        </label>
      )}

      <div
        className={`${classes.inputContainer} ${inputContainerClass} d-flex align-items-center gap-2`}
        ref={dropdownRef}
      >
        {search && <FiSearch color="var(--text-secondary-color)"/>}

        {isSelect ? (
          <div
            className={classes.customSelect}
            onClick={() => setShowDropdown((prev) => !prev)}
          >
            <span>{value || placeholder || "Select an option"}</span>
            {showDropdown && (
              <div className={classes.dropdownWrapper}>
                {showSearch && (
                  <input
                    type="text"
                    placeholder="Search..."
                    className={classes.searchInput}
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    onClick={(e) => e.stopPropagation()}
                  />
                )}
                <ul className={classes.dropdownList}>
                  {options
                    .filter((opt) =>
                      opt.toLowerCase().includes(searchTerm.toLowerCase())
                    )
                    .map((opt) => (
                      <li
                        key={opt}
                        onClick={(e) => {
                          e.stopPropagation();
                          onChange({ target: { name, value: opt } });
                          setShowDropdown(false);
                          setSearchTerm("");
                        }}
                      >
                        {opt}
                      </li>
                    ))}
                </ul>
              </div>
            )}
          </div>
        ) : isTextarea ? (
          <textarea
            className={classes.textarea}
            placeholder={placeholder}
            onChange={onChange}
            name={name}
            value={value}
            disabled={disabled}
            required={required}
            rows={5}
          />
        ) : (
          <input
            type={showPassword ? "text" : type}
            placeholder={placeholder}
            onChange={onChange}
            name={name}
            value={value}
            disabled={disabled}
            required={required}
          />
        )}

        {showEye &&
          type === "password" &&
          !isSelect &&
          !isTextarea &&
          (showPassword ? (
            <IoEyeOutline
              size={24}
              color="#737373"
              role="button"
              onClick={() => setShowPassword(false)}
            />
          ) : (
            <IoEyeOffOutline
              size={24}
              color="#737373"
              role="button"
              onClick={() => setShowPassword(true)}
            />
          ))}
      </div>
    </div>
  );
};

export default InputField;